import { motion } from "framer-motion";
import { TECH_LIST, IMAGES } from "@/lib/content";
import { fadeUp, stagger } from "@/lib/motion";

export default function Technology() {
  return (
    <section
      id="technology"
      data-testid="technology-section"
      className="relative bg-ink-950 py-28 md:py-40 border-t border-ivory/[0.06]"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            className="col-span-12 md:col-span-5 order-2 md:order-1"
          >
            <div className="font-mono-caps text-[10px] text-copper mb-6">
              <span className="mr-3">§ 07</span> Technology & Innovation
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ivory">
              Building with<br />
              <span className="italic text-copper">modern tools.</span>
            </h2>
            <p className="mt-8 text-ivory/60 max-w-md leading-relaxed">
              A practice hard-wired for how buyers, investors and developers actually operate in
              2026 — from visualisation and marketing to construction monitoring and AI.
            </p>

            <motion.ul
              variants={stagger}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8"
            >
              {TECH_LIST.map((t, i) => (
                <motion.li
                  key={t}
                  variants={fadeUp}
                  data-testid={`tech-item-${i}`}
                  className="group flex items-baseline gap-4 py-3 border-b border-ivory/[0.06]"
                >
                  <span className="font-mono text-[10px] text-copper/70 w-8">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-ivory group-hover:text-copper transition-colors duration-300">
                    {t}
                  </span>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 1.03 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-7 order-1 md:order-2"
          >
            <div className="relative clip-frame overflow-hidden border border-ivory/10 aspect-[16/11]">
              <img
                src={IMAGES.blueprint}
                alt="Architectural blueprint"
                className="absolute inset-0 h-full w-full object-cover grayscale opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-ink-950 via-ink-950/30 to-transparent" />
              <div className="absolute top-4 left-4 right-4 flex items-center justify-between font-mono-caps text-[9px] text-ivory/70">
                <span>PM · Studio</span>
                <span>Plan · Rev 04</span>
              </div>
              <div className="absolute bottom-4 left-4 font-mono-caps text-[9px] text-copper">
                LATITUDE 19.23° N · LONGITUDE 72.86° E
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
